
export default class QuoteLiteModel {
  constructor(quoteObj) {
    this.quoteId = quoteObj?.quoteId
    this.quoteNo = quoteObj?.quoteNo
    this.subQuoteNo = quoteObj?.subQuoteNo
    this.quoteDate = quoteObj?.quoteDate
    this.labourType = quoteObj?.labourType
    this.deleted = quoteObj?.deleted
    this.excessWithGst = quoteObj?.excessWithGst
    this.labourTotal = quoteObj?.labourTotal
    this.partTotal = quoteObj?.partTotal
    this.miscTotal = quoteObj?.miscTotal
    this.authorisedAmount = quoteObj?.authorisedAmount
    this.rrTotal = quoteObj?.rrTotal
    this.repairTotal = quoteObj?.repairTotal
    this.paintTotal = quoteObj?.paintTotal
    this.rwaTotal = quoteObj?.rwaTotal
    this.fgTotal = quoteObj?.fgTotal
    this.cdTotal = quoteObj?.cdTotal
    this.crushTotal = quoteObj?.crushTotal
    this.mechTotal = quoteObj?.mechTotal
    this.sublTotal = quoteObj?.sublTotal
    this.opgTotal = quoteObj?.opgTotal
    this.totalExGst = quoteObj?.totalExGst
    this.totalIncGst = quoteObj?.totalIncGst
    this.isAssessmentEnabled = quoteObj?.isAssessmentEnabled
    this.createdBy = quoteObj?.createdBy
    this.createdDate = quoteObj?.createdDate
    this.modifiedBy = quoteObj?.modifiedBy
    this.modifiedDate = quoteObj?.modifiedDate
    this.isNew = quoteObj?.isNew
    this.isDeleted = quoteObj?.isDeleted
    this.isDirty = quoteObj?.isDirty
    this.overwriteOnConflict = quoteObj?.overwriteOnConflict
    this.mergeOnConflict = quoteObj?.mergeOnConflict
  }
}
